export default __webpack_public_path__ + "static/media/BELL_CA.fb39db5e.png";